import { classNames } from "../../../lib/class-names";
import BoxIcon from "../box-icon/box-icon";
import "./icon-description.scss";

type DescriptionIconProps = {
  icon: string | number;
  title: string;
  text: string;
  type: "primary" | "secondary" | "primary-rounded" | "secondary-rounded";
  size: "small" | "medium" | "big";
  color?: "light" | "dark";
  direction?: "vertical" | "horizontal" | "vertical-left";
};

const IconDescription = ({
  icon,
  title,
  text,
  type,
  size,
  color = "light",
  direction = "horizontal",
}: DescriptionIconProps) => {
  const iconDescriptionClasses = classNames({
    "icon-description": true,
    "icon-description--vertical": direction === "vertical",
    "icon-description--vertical-left": direction === "vertical-left",
  });

  const titleClasses = classNames({
    "icon-description__title": true,
    "icon-description__title--light": color === "light",
    "icon-description__title--dark": color === "dark",
  });

  const textClasses = classNames({
    "icon-description__text": true,
    "icon-description__text--light": color === "light",
    "icon-description__text--dark": color === "dark",
  });
  return (
    <div className={iconDescriptionClasses}>
      <div className="icon-description__icon">
        <BoxIcon icon={icon} size={size} type={type} />
      </div>
      <div className="icon-description__description">
        <h3 className={titleClasses}>{title}</h3>
        <p className={textClasses}>{text}</p>
      </div>
    </div>
  );
};

export default IconDescription;
